import React from "react"

import SimplePage from "layouts/SimplePage"

import "./About.sass"

const About = () => {
  return (
    <>
      <SimplePage className="About" isTinted>
        <h1>O storitvi</h1>

        <p>
          Avtolog je nepogrešljivo orodje, ki obiskovalcem omogoča pregled
          dostopnih podatkov o zgodovini vozila in pomaga pri ustvarjanju
          varnega in urejenega avtomobilskega trga. Avtolog je z oktobrom 2019
          postal del skupine AMZS. AMZS bo s svojim znanjem in izkušnjami
          omogočal nadaljni razvoj projekta. Skupaj bomo nadaljevali poslanstvo
          projekta in se še naprej trudili, da bodo podatki javno dostopni in da
          bomo skupaj ustvarjali varen in urejen avtomobilski trg. Odslej v
          modernejši podobi in po novem tudi z mobilno aplikacijo.
        </p>

        <p>
          Avtolog so ustvarili člani Podatkovnega inštituta Inforum. Avtolog
          deluje na zbirki podatkov o registriranih motornih vozilih v
          Sloveniji, ki so javno dostopni na portalu OPSI. Z izboljšanim
          prikazom podatkov Avtolog ponuja uporabniku prijazno izkušnjo pri
          pregledu trenutnih trendov, kot tudi omogoča poglobljeno iskanje
          podatkov o posameznih vozilih.
        </p>

        <p>
          Pregled trendov omogoča boljšo osveščenost uporabnika pri nakupu in
          izbiri vsakdanjega prevoznega sredstva tudi z okoljevarstvenega vidika
          (škodljivi izpusti, EURO standard). Hkrati krepimo zavedanje o
          varnosti in tehnični izpravnosti vozil ter z dostopnostjo podatkov
          pomagamo odločitvi za nakup rabljenega vozila. Iskanje podatkov o
          posameznih vozilih pripomore k boljši informiranosti uporabnika in
          zmanjšuje tveganje za prevaro pri nakupih vozil.
        </p>

        <h2>Zogodovina Avtolog</h2>

        <ul>
          <li>
            <strong>2020-10-20</strong>{" "}
            <span className="detail">Avtolog postane del skupine AMZS</span>
          </li>
          <li>
            <strong>2020-07-01</strong>{" "}
            <span className="detail">
              Dodani podatki evidenc za prvi polletje 2020.
            </span>
          </li>
          <li>
            <strong>2020-01-30</strong>{" "}
            <span className="detail">
              Dodani podatki evidenc za drugo polletje 2019. Dodani podatki
              tehničnih pregledov za leto 2019.
            </span>
          </li>
          <li>
            <strong>2019-07-01</strong>{" "}
            <span className="detail">
              Dodani podatki evidenc za prvo polletje 2019
            </span>
          </li>
          <li>
            <strong>2019-05-28</strong>{" "}
            <span className="detail">
              Popravljene vrednosti o starosti lastnika in uporabnika vozila -
              napaka v izvornih datotekah
            </span>
          </li>
          <li>
            <strong>2019-05-06</strong>{" "}
            <span className="detail">
              Dodani podatki o iz evidence ukradenih vozil
            </span>
          </li>
          <li>
            <strong>2019-05-02</strong>{" "}
            <span className="detail">
              Dodani podatki o lastništvu avtomobila (starost in tip lastnika in
              uporabnika)
            </span>
          </li>
          <li>
            <strong>2019-04-18</strong>{" "}
            <span className="detail">
              Nadgradnja strani - vozila s prevrtenimi kilometri so obarvana,
              dodan graf nenaključno naključnega vozila
            </span>
          </li>
          <li>
            <strong>2019-03-18</strong>{" "}
            <span className="detail">
              Dodani podatki o uspešnosti tehničnih pregledov
            </span>
          </li>
          <li>
            <strong>2019-02-25</strong>{" "}
            <span className="detail">
              Nove vizualizacije in funkcionalnosti
            </span>
          </li>
          <li>
            <strong>2019-01-08</strong>{" "}
            <span className="detail">Prva objava strani Avtolog</span>
          </li>
        </ul>
      </SimplePage>
    </>
  )
}

export default About
